export const inputValidation = (data, courierType, useType, inputType) => {
  if (useType === "edit") {
    if (!data.basePrice) {
      return {
        error: true,
        message: "Silahkan isi harga dasar terlebih dahulu",
      };
    }
  }
  if (courierType === "express" && useType === "create") {
    if (!data.origin || !data.destination || !data.basePrice || !inputType) {
      return {
        error: true,
        message: "Silahkan lengkapi input data terlebih dahulu",
      };
    }
  }
  if (courierType === "instant" && useType === "create") {
    if (
      !data.originLat ||
      !data.originLng ||
      !data.destinationLat ||
      !data.destinationLng ||
      !data.basePrice
    ) {
      return {
        error: true,
        message: "Silahkan lengkapi input data terlebih dahulu",
      };
    }
  }

  return {
    error: false,
  };
};
